import React from 'react'
import styled from 'styled-components'

const Iframe = styled.iframe`
  margin-top: 0;

  @media (max-width: 992px) {
    height: 2000px;
  }
`

interface TextIframeEmbedProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Text
}

function TextIframeEmbed({ fields }: TextIframeEmbedProps) {
  return (
    <section>
      <div className="overflow-hidden">
        <Iframe
          src={fields?.iframeUrl ?? undefined}
          width="100%"
          style={{
            border: '0px #FFFFFF none',
            height: '100vh',
            maxHeight: '1400px',
          }}
          frameBorder="0"
          title="iFrame embed"
          scrolling="0"
        />
      </div>
    </section>
  )
}

export default TextIframeEmbed
